import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

//importing modules
import auth from './modules/auth';
import app from './modules/app';
import company from './modules/company';
import screening from './modules/screening';
import page from './modules/page';
import createMutationsSharer from 'vuex-shared-mutations';
import consumer from './modules/consumer';
import monetization from './modules/monetization';
import bookings from './modules/bookings';
import affiliation from './modules/affiliation';
import player from "./modules/player"
import chatroom from "./modules/chatroom"
import plan from "./modules/plan"
import subscription from "./modules/subscription"
Vue.use (Vuex);

export default new Vuex.Store ({
  state: {},
  actions: {
    resetAll({commit}) {
      commit ('app/reset');
      commit ('auth/reset');
      commit ('company/reset');
      commit ('screening/reset');
      commit ('consumer/reset');
      commit ('monetization/reset');
      commit ('bookings/reset');
      commit ('affiliation/reset');
      commit ('player/reset');
      commit ('plan/reset');
      commit ('subscription/reset');
    },
  },
  modules: {
    auth,
    app,
    company,
    screening,
    consumer,
    page,
    monetization,
    bookings,
    affiliation,
    player,
    chatroom,
    plan,
    subscription
  },
  plugins: [
    createPersistedState ({
      key: 'il-film-screening',
      /**
       * FIXME: the plugin doesn't have option of excluding paths
       * so need to include all the modules which we need to be persist
       * NEED to find a way to do it programmatically to add the module
       */
      paths: ['auth', 'app', 'company', 'screening', 'consumer', 'page', 'affiliation', 'player'],
    }),
    createMutationsSharer ({
      predicate: [
        //syncing only session related states
        'auth/set_key',
        'auth/set_secret',
      ],
    }),
  ],
});
